export function errorMessage(state = '', action) {
  switch (action.type) {
    case 'USER_LOGGED_IN_ERROR':
      return action.message
    case 'ERASE_ERROR':
      return ''
    default:
      return state
  }
}

export function jobs(state = [], action) {
  switch (action.type) {
    case 'GET_JOBS':
      return action.json
    case 'ERASE_JOBS':
      return ''
    default:
      return state
  }
}

export function links(state = {}, action) {
  switch (action.type) {
    case 'GET_LINKS':
      return action.json
    case 'NO_LINKS':
      return []
    case 'ERASE_LINKS':
      return ''
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/common.jsx